import { useContext } from 'react';
import { FlowBuilderContext } from '../context';
import { BasicEdgeCore } from 'pages/AutomationEngine/Engine/Flow/edges';
import { type EdgeProps, useNodes } from 'reactflow';

export const BasicEdge = ({ source, target, ...props }: EdgeProps) => {
  const { placing, lastPlacingStep } = useContext(FlowBuilderContext);

  const nodes = useNodes<{ leaf: boolean }>();

  if (
    placing &&
    source === lastPlacingStep?.id &&
    nodes.find((n) => n.id === target)?.data?.leaf
  ) {
    return null;
  }

  return <BasicEdgeCore source={source} target={target} {...props} />;
};
